export enum RFPStatus {
  Open,
  Closed,
  InReview,
  Approved,
  Rejected,
}

export const getRFPStatusString = (status: RFPStatus): string => {
  return RFPStatus[status];
};
